module.exports = "/_next/static/images/cabs-header-a0ee9334775486bb375f0cea64e1de55.webp";